var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3178_9070)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 17.5,
    r: 10.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3664 12.2068C24.3664 12.0486 24.3024 11.8969 24.1883 11.7851C24.0743 11.6732 23.9197 11.6104 23.7584 11.6104C23.5971 11.6104 23.4425 11.6732 23.3284 11.7851C23.2144 11.8969 23.1503 12.0486 23.1503 12.2068V12.6542H22.8117C22.1599 12.6541 21.5325 12.8978 21.0574 13.3355C20.5823 13.7732 20.2951 14.3721 20.2542 15.0103L20.1199 17.1183C20.0686 17.922 19.7935 18.6965 19.3246 19.3574C19.2277 19.4941 19.1684 19.653 19.1527 19.8187C19.1369 19.9844 19.1652 20.1513 19.2346 20.3032C19.3041 20.455 19.4125 20.5867 19.5491 20.6853C19.6858 20.7839 19.8462 20.8461 20.0147 20.8659L22.0863 21.1093V21.7505C22.0863 22.1856 22.2624 22.6028 22.576 22.9104C22.8896 23.218 23.3149 23.3908 23.7584 23.3908C24.2019 23.3908 24.6272 23.218 24.9408 22.9104C25.2543 22.6028 25.4305 22.1856 25.4305 21.7505V21.1093L27.5021 20.8653C27.6705 20.8455 27.8307 20.7832 27.9673 20.6847C28.1039 20.5861 28.2122 20.4545 28.2817 20.3028C28.3512 20.151 28.3794 19.9842 28.3637 19.8186C28.3481 19.6529 28.289 19.4941 28.1922 19.3574C27.7232 18.6965 27.4481 17.922 27.3969 17.1183L27.2625 15.0109C27.2218 14.3726 26.9347 13.7736 26.4596 13.3357C25.9844 12.8979 25.357 12.6542 24.7051 12.6542H24.3664V12.2068ZM22.8117 13.5489C22.3919 13.5489 21.9878 13.7058 21.6818 13.9877C21.3758 14.2696 21.1908 14.6553 21.1645 15.0664L21.0307 17.1743C20.9689 18.1412 20.6379 19.0729 20.0737 19.868C20.0666 19.8779 20.0624 19.8894 20.0612 19.9014C20.0601 19.9134 20.0621 19.9254 20.0671 19.9364C20.0721 19.9474 20.08 19.9569 20.0899 19.9641C20.0997 19.9712 20.1113 19.9757 20.1235 19.9772L22.3958 20.245C23.3011 20.3512 24.2156 20.3512 25.121 20.245L27.3933 19.9772C27.4054 19.9757 27.417 19.9712 27.4269 19.9641C27.4368 19.9569 27.4446 19.9474 27.4497 19.9364C27.4547 19.9254 27.4567 19.9134 27.4556 19.9014C27.4544 19.8894 27.4501 19.8779 27.4431 19.868C26.8791 19.0729 26.5483 18.1411 26.4867 17.1743L26.3523 15.0664C26.326 14.6553 26.141 14.2696 25.835 13.9877C25.529 13.7058 25.1249 13.5489 24.7051 13.5489H22.8117ZM23.7584 22.4961C23.3388 22.4961 22.9983 22.1621 22.9983 21.7505V21.3032H24.5184V21.7505C24.5184 22.1621 24.1779 22.4961 23.7584 22.4961Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3178_9070",
    x: 0,
    y: 0,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.611765 0 0 0 0 0.882353 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3178_9070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3178_9070",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconMobile);
export default __webpack_public_path__ + "static/media/NotificationIconMobile.0f2346a026ecc9a2f7be81cb0e0dea84.svg";
export { ForwardRef as ReactComponent };